import { useUnsavedChangesGuard } from '~/hooks/useUnsavedChangesGuard';
import { useAuthentication } from '~/hooks/useAuthentication';
import { schema, Schema } from './result-record-form.schema';
import { Select } from '~/components/Input/Select/Select';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Schema) => void;
  defaultValues?: Schema;
  isLoading: boolean;
}

export function ResultRecordForm({ defaultValues, isLoading, onSubmit }: Props) {
  const { isSuperUser } = useAuthentication();

  const { formState, register, handleSubmit } = useForm({
    defaultValues: defaultValues ?? {},
    resolver: zodResolver(schema),
  });

  const { dialog } = useUnsavedChangesGuard(formState);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="national_record_status" label="Svenskt rekord">
            <Select
              {...register('national_record_status', { disabled: !isSuperUser })}
              options={[
                ['Default', 'default'],
                ['Manuellt inkludera', 'include'],
                ['Manuellt exkludera', 'exclude'],
              ]}
            />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="district_record_status" label="Distriktsrekord">
            <Select
              {...register('district_record_status')}
              options={[
                ['Default', 'default'],
                ['Manuellt inkludera', 'include'],
                ['Manuellt exkludera', 'exclude'],
              ]}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          Spara
        </Button>
      </Button.Group>

      {dialog}
    </form>
  );
}
